'use strict'

module.exports = [

	{name: 'showcase', groups: ['Články'],
		sections: ['top', 'full'],
	},
	{name: 'category', groups: ['Články'],
		sections: ['full', 'large'],
	},
	{name: 'category-top', groups: ['Články'],
		sections: ['full', 'large'],
	},
	{name: 'category-sidebar', groups: ['Články'],
		sections: ['small'],
	},

	{name: 'title', groups: ['Článok'],
		sections: ['full', 'large', 'small'],
	},
	{name: 'abstract', groups: ['Článok'],
		sections: ['top', 'bottom', 'full', 'large', 'small'],
	},
	{name: 'html-table', groups: ['Článok'],
		sections: ['top', 'bottom', 'full', 'large', 'small'],
	},
	{name: 'content-block', groups: ['Článok'],
		sections: ['top', 'bottom', 'full', 'large', 'small'],
	},
	{name: 'content-col-large', groups: ['Článok'],
		sections: ['top', 'bottom', 'full', 'large'],
	},
	{name: 'content-col-small', groups: ['Článok'],
		sections: ['top', 'bottom', 'full', 'large'],
	},

	{name: 'file-list', groups: ['Článok'],
		sections: ['top', 'bottom', 'full', 'large', 'small'],
	},

	{name: 'file-list-without-date', groups: ['Článok'],
		sections: ['top', 'bottom', 'full', 'large', 'small'],
	},

]



//////////////////
// WEBPACK FOOTER
// ./src/blocks/_multi-article.js
// module id = 146
// module chunks = 0